export default {
      id: "icon-instagram-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "icons.svg#icon-instagram",
      toString: function () {
        return this.url;
      }
    }